import React from "react";

export default function TeacherMocksPagination({ page, totalPages, onPageChange }) {
  const start = Math.max(1, page - 2);
  const end = Math.min(totalPages, page + 2);
  const pages = Array.from({ length: end - start + 1 }, (_, index) => start + index);

  return (
    <nav className="tprof-pagination" aria-label="Paginacao dos simulados">
      <button type="button" disabled={page <= 1} onClick={() => onPageChange(page - 1)}>
        Anterior
      </button>
      {start > 1 && <span>...</span>}
      {pages.map((item) => (
        <button
          key={item}
          type="button"
          className={item === page ? "active" : ""}
          onClick={() => onPageChange(item)}
        >
          {item}
        </button>
      ))}
      {end < totalPages && <span>...</span>}
      <button type="button" disabled={page >= totalPages} onClick={() => onPageChange(page + 1)}>
        Proxima
      </button>
    </nav>
  );
}
